// extracted by mini-css-extract-plugin
export default {"background":"thanks_background__L0B-+"};